import MasonryWrapper from './masonry-wrapper/MasonryWrapper.vue';
import SimpleTabs from './simple-tabs/SimpleTabs.vue';
import SearchResultsLister from './search/SearchResultsLister.vue';
import SearchFilterPanel from './search/SearchFilterPanel.vue';
import SearchWrapper from './search/SearchWrapper.vue';

export function registerComponents(app) {
  app.component('masonry-wrapper', MasonryWrapper);
  app.component('simple-tabs', SimpleTabs);
  app.component('search-results-lister', SearchResultsLister);
  app.component('search-filter-panel', SearchFilterPanel);
  app.component('search-wrapper', SearchWrapper);
}
